function About() {
  return (
    <section id="a-propos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-serif text-text">À propos</h2>
          <p className="text-primary tracking-widest uppercase font-sans">
            Notre histoire
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 md:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-xl">
              <img
                src="/images/photo_a_propos.png"
                alt="Les deux sœurs fondatrices"
                className="w-full h-[400px] object-cover"
              />
            </div>
          </div>

          <div className="order-1 md:order-2 space-y-6">
            <h3 className="text-3xl font-serif text-text">
              Une aventure de famille
            </h3>
            <p className="text-text/80 leading-relaxed font-sans">
              Les Jolies Choses, c'est avant tout une aventure de famille : deux sœurs passionnées de mode, d'élégance et de belles trouvailles.
              Depuis plus de 15 ans, nous sélectionnons avec soin des vêtements et accessoires féminins pour offrir une expérience unique de seconde main : loin des clichés du luxe ou du vintage, mais toujours chic, actuelle et accessible.
            </p>
            <p className="text-text/80 leading-relaxed font-sans">
              Notre mission ? Donner une nouvelle vie aux pièces tendance tout en valorisant le conseil, la convivialité et les relations humaines.
              Ancrées à Marseille, nous croyons qu'une mode responsable peut aussi être joyeuse, féminine et authentique.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-secondary to-secondary/50 p-8 rounded-2xl shadow-sm border border-secondary/30 text-center space-y-4">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </div>
            <h4 className="text-text font-serif text-lg">Sélection soignée</h4>
            <p className="text-text/70 font-sans">
              Chaque article est choisi avec soin pour garantir qualité et style
            </p>
          </div>

          <div className="bg-gradient-to-br from-secondary to-secondary/50 p-8 rounded-2xl shadow-sm border border-secondary/30 text-center space-y-4">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <h4 className="text-text font-serif text-lg">Mode durable</h4>
            <p className="text-text/70 font-sans">
              Donnez une seconde vie aux vêtements et adoptez une mode responsable
            </p>
          </div>

          <div className="bg-gradient-to-br from-secondary to-secondary/50 p-8 rounded-2xl shadow-sm border border-secondary/30 text-center space-y-4">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </div>
            <h4 className="text-text font-serif text-lg">Convivialité & conseil</h4>
            <p className="text-text/70 font-sans">
              Un service personnalisé basé sur les relations humaines et la bienveillance
            </p>
          </div>
        </div>

        {/* Section mise en avant produit */}
        <div className="mt-20 bg-gradient-to-br from-secondary via-secondary/80 to-secondary/50 rounded-3xl overflow-hidden shadow-xl">
          <div className="grid md:grid-cols-2 gap-0 items-center">
            <div className="p-12 space-y-6">
              <p className="text-primary tracking-widest uppercase font-sans">
                Nos pièces d'exception
              </p>
              <h3 className="text-3xl font-serif text-text">
                Des accessoires de qualité
              </h3>
              <p className="text-text/80 leading-relaxed font-sans">
                Découvrez notre sélection d'accessoires de grandes marques, 
                soigneusement choisis pour leur qualité et leur intemporalité. 
                Chaque pièce raconte une histoire et attend de trouver sa nouvelle propriétaire.
              </p>
              <div className="pt-4 space-y-4">
                <p className="text-text/70 italic font-sans">
                  Pour voir nos dernières pièces et nos dernières vitrines, rendez-vous sur nos réseaux
                </p>
                <div className="flex items-center gap-3">
                  <a
                    href="https://www.instagram.com/lesjolieschosesmarseille/?hl=fr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-full flex items-center justify-center hover:from-primary/30 hover:to-primary/20 transition-all duration-300 shadow-sm hover:shadow-md"
                    aria-label="Instagram"
                  >
                    <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                  <a
                    href="https://www.facebook.com/lesjolieschosesdepotventemarseille/?locale=fr_FR"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-full flex items-center justify-center hover:from-primary/30 hover:to-primary/20 transition-all duration-300 shadow-sm hover:shadow-md"
                    aria-label="Facebook"
                  >
                    <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="h-full">
              <img
                src="/images/photo_pieces_exceptions.png"
                alt="Pièces d'exception - Accessoires de qualité"
                className="w-full h-full min-h-[400px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

